import { BorderColor, Delete, Visibility } from '@mui/icons-material';
import { Button, ButtonGroup, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Link, Tooltip } from '@mui/material';
import { DataGrid, GridCellParams, GridColDef } from '@mui/x-data-grid';
import axios from 'axios';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useSnackbarAlert from '../../../utils/snackbarHandlers';

const ListRenderer: React.FC<any> = () => {
    //@ts-ignore
    const config = window.config;
    const apiBaseURL = config?.server || 'http://18.217.95.31:8080';
    const { showErrorMessage, showSuccessMessage } = useSnackbarAlert();
    const { t } = useTranslation('translation');
    const [data, setData] = React.useState<Array<any>>([]);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [totalCount, setTotalCount] = React.useState<number>(0);
    const [refreshTable, setRefreshTable] = React.useState<number>(0);
    const [dialogBox, setDialogBox] = React.useState(false);
    const [deleteId, setDeleteId] = React.useState();
    const navigate = useNavigate();
    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 10,
    });

    const payload = {
        pageSize: paginationModel.pageSize,
        pageNumber: paginationModel.page + 1,
        status: ["ACTIVE", "DELETED"]
    };

    React.useEffect(() => {
        setLoading(true);
        axios.post(`${apiBaseURL}/api/ticket/fetchAllTickets`, payload)
            .then((res: any) => {
                setData(res?.data?.tickets)
                setTotalCount(res?.data?.totalRecords)
            })
            .catch((error: Error) => {
                console.log("err", error)
            })
            .finally(() => setLoading(false));
    }, [paginationModel, refreshTable]);

    //need to change lastUpdatedBy value with loggedin User once localstorage is set
    const handleDelete = React.useCallback((id: any) => {
        axios.delete(`${apiBaseURL}/api/ticket/deleteTicket?id=${id}`)
            .then((res: any) => {
                setDialogBox(false);
                setRefreshTable(Math.random());
                showSuccessMessage(t("deletedSuccessMessage"));
                // enqueueSnackbar("Deleted", { variant: "success" });
            })
            .catch((error: Error) => {
                showErrorMessage(error)
            })
    }, []);

    const handleCloseDialogbox = () => {
        setDialogBox(false);
    }

    const columns: GridColDef[] = [
        {
            field: 'ticketTitle',
            headerName: 'Ticket title',
            width: 200,
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: 'ticketNumber',
            headerName: 'Ticket number',
            width: 200,
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: 'status',
            headerName: 'Status',
            width: 200,
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: 'createdAt',
            headerName: 'Date',
            width: 200,
            align: "center",
            headerAlign: "center",
            flex: 1,
            valueFormatter: (params: any) => {
                const creationDate = params.value;
                // return (
                //     (creationDate?.split("T")[0] as string) +
                //     " " +
                //     (creationDate?.split("T")[1] as string)?.slice(0, 8)
                // );
                const date = creationDate?.split("T")[0];
                const splittedDate = date.split("-");
                const formattedDate = `${splittedDate[1]}-${splittedDate[2]}-${splittedDate[0]}`;
                return formattedDate;
            },
        },
        {
            field: 'ticketPrice',
            headerName: 'Amount',
            width: 200,
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: 'startDate',
            headerName: 'Start Date',
            width: 200,
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: 'closeDate',
            headerName: 'Close Date',
            width: 200,
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: 'numberOfPack',
            headerName: 'Number of Pack',
            width: 200,
            align: "center",
            headerAlign: "center",
            flex: 1,
        },
        {
            field: "actions",
            headerName: "Actions",
            sortable: false,
            filterable: false,
            align: "center",
            headerAlign: "center",
            width: 200,
            renderCell: (params: GridCellParams) => {
                return (
                    <ButtonGroup size="small" color="inherit" aria-label="group action buttons">
                        <Tooltip title="View">
                            <Button
                                onClick={(e) => navigate(`/admin/viewTicket/${params.row.Id}`)}
                            >
                                <Visibility fontSize="small" />
                            </Button>
                        </Tooltip>
                        <Tooltip title="Edit">
                            <Button
                                onClick={(e) => navigate(`/admin/editTicket/${params.row.Id}`)}
                            >
                                <BorderColor fontSize="small" />
                            </Button>
                        </Tooltip>
                        {params.row.status !== "DELETED" &&
                            (
                                <Tooltip title="Delete">
                                    <Button
                                        onClick={() => {
                                            setDialogBox(true);
                                            setDeleteId(params.row.Id);
                                        }}
                                    >
                                        <Delete fontSize="small" />
                                    </Button>
                                </Tooltip>
                            )}
                    </ButtonGroup>
                );
            },
            flex: 1,
        },
    ];



    return (
        <>
            <Dialog
                open={dialogBox}
                onClose={handleCloseDialogbox}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {t('deleteTicket')}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {t('deleteTicketConfirmation')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialogbox}>{t('disagree')}</Button>
                    <Button onClick={() => handleDelete(deleteId)} autoFocus>
                        {t('agree')}
                    </Button>
                </DialogActions>
            </Dialog>
            <Grid className="w-full" style={{
                marginTop: "1%",
                height: "630px",
            }}>
                <DataGrid
                    rows={data}
                    loading={loading}
                    columns={columns}
                    rowCount={totalCount}
                    pageSizeOptions={[10, 20, 50, 100]}
                    pagination
                    paginationMode="server"
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    getRowId={(row) => row.Id}
                    disableColumnSelector
                    disableRowSelectionOnClick
                    sx={{
                        '& .MuiDataGrid-main': {
                            borderColor: "#DAA520",
                        },
                        '& .MuiDataGrid-columnHeader': {
                            backgroundColor: "#F5F5E6",

                        },
                        '& .MuiDataGrid-columnHeaderTitle': {
                            fontWeight: 600,

                        },
                        '& .MuiDataGrid-row.Mui-odd': {
                            backgroundColor: "#F5F5E6",
                        }
                        // maxWidth: "fit-content",
                    }}
                    getRowClassName={(params) => {
                        return params.id as number % 2 === 0 ? 'Mui-even' : 'Mui-odd'
                    }
                    }
                    columnBuffer={0}
                // autoHeight

                />
            </Grid>
        </>
    );
}
export default ListRenderer;